import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fmtUSD } from "@/lib/api";

export default function PackageCard({ pkg, index = 0 }) {
    return (
        <article
            data-testid={`package-card-${pkg.id}`}
            className="group bg-white border border-palm-400/30 rounded-sm overflow-hidden hover:-translate-y-1 transition-transform duration-300 animate-fade-up"
            style={{ animationDelay: `${index * 80}ms` }}
        >
            <div className="aspect-[4/3] overflow-hidden bg-sand-200">
                <img
                    src={pkg.image_url}
                    alt={pkg.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                    loading="lazy"
                />
            </div>
            <div className="p-7 flex flex-col gap-3">
                <div className="flex items-center justify-between">
                    <span className="overline">
                        {pkg.category === "drop_off" ? "Drop Off" : "On-Site Chef"}
                    </span>
                    <span className="text-xs text-forest-400">
                        Min {pkg.min_guests} guests
                    </span>
                </div>
                <h3 className="font-serif text-2xl md:text-3xl text-forest-700 leading-tight">
                    {pkg.name}
                </h3>
                <p className="text-sm text-forest-700/60 leading-relaxed">
                    {pkg.short_description}
                </p>
                <div className="flex items-end justify-between mt-3 pt-4 border-t border-palm-400/30">
                    <div>
                        <div className="font-serif text-3xl text-emerald-600">
                            {pkg.flat_price
                                ? fmtUSD(pkg.flat_price)
                                : fmtUSD(pkg.price_per_person)}
                        </div>
                        <div className="text-xs text-forest-700/60 mt-1">
                            {pkg.flat_price ? pkg.serves || "Flat rate" : "per person"}
                        </div>
                    </div>
                    <Link
                        to={`/packages/${pkg.id}`}
                        data-testid={`view-package-${pkg.id}`}
                        className="inline-flex items-center gap-1.5 text-sm text-forest-700 group/btn"
                    >
                        View
                        <ArrowUpRight
                            className="w-4 h-4 group-hover/btn:translate-x-0.5 group-hover/btn:-translate-y-0.5 transition-transform"
                            strokeWidth={1.5}
                        />
                    </Link>
                </div>
            </div>
        </article>
    );
}
